export const themes = {
  primary: '#7C0E6F',
  lightprimary: '#f2e6f0',
  greyDefault: '#757575',
  greyDefault_500: '#9E9E9E',
  greySubtitle: '#8F95B2',
  blackDefault: '#000000',
  darkBlue: '#081735',
  defaultSuccess: '#4CAF50',
  defaultMisc: '#FFB400',
  lightMisc: '#FFF7E5',
  defaultInfo: '#0D3C61',
  defaultIcon: '#575757',
  primaryMain: '#7C0E6F',
  defaultScondary_blue: '#0C2372',
  dashboardColor: '#F5F5FA',
  greyModalTitle: '#8181A5',
  defaultError: '#F44336',
  tileValue_black: '#000000DE',
  tileKey_grey: '#0000008A',
  grey_colorDesignationAR: '#92929D',
  editCardHeader_blue: '#263971',
  lightRedSubtittle: '#FF5263',
  defaultInfoBlue: '#2196F3',
  red: '#F44336',
  green: '#4CAF50',
  yellow: '#FF9800',
  leaveCalender: '#B4DEBB',
  holidayCalender: '#ff96f3',
  weekoffCalender: '#fce881',
  absentCalender: '#db6960',
  shiftDays: '#616161',
};

export const fonts = {
  title: '14px',
  subtitle: '12px',
  smallSize: '10px',
  header: '16px',
  xl_25: '25px',
  fontFamily: 'Lato, sans-serif',
  fontstyle: 'italic',
  fontWeight: 'bold',
  xxl: '32px',
};
